
const API_BASE_URL = process.env.REACT_APP_BACKEND

// Patient endpoints
export const PATIENT_API_BASE_URL = `${API_BASE_URL}/api/patient/`

// Member endpoints
export const MEMBER_API_BASE_URL = `${API_BASE_URL}/api/member/`

// Medical History endpoints
export const MEDICAL_HISTORY_API_BASE_URL = `${PATIENT_API_BASE_URL}/medical-history/`

// Medical History Category endpoints
export const MEDICAL_HISTORY_CATEGORY_API_BASE_URL = `${API_BASE_URL}/api/medicle-category/`

// Appintment endpoints
export const APPOINTMENT_API_BASE_URL = `${API_BASE_URL}/api/appointments/`

// Appointment endpoints
export const APPOINTMENT_ENDPOINT_SUFFIX = '/appointmnets/'

// Medical History endpoints
export const MEDICAL_HISTORY_ENDPOINT_SUFFIX = '/medical-history/'

// Medical History Category
export const MEDICAL_HISTORY_CATEGORY_ENDPOINT_SUFFIX = '/medicle-category/'

// Screening endpoints
export const SCREENING_ENDPOINT_SUFFIX = '/screening/'

// Anonymous endpoints
export const ANONYMOUS_PATIENT_ENDPOINT_SUFFIX = '/anonymous/'

// Auth0 endpoints
export const AUTH0_PATIENT_ENDPOINT_SUFFIX = '/auth0/'

// Health Screening endpoints
export const HEALTH_SCREENING_ENDPOINT_SUFFIX = '/health-screening/'

// Anonymous Appointment
export const APPOINTMENT_ANONYMOUS_ENDPOINT_SUFFIX = '/appointment/anonymous/'

// Anonymous Health Screening endpoints
export const HEALTH_SCREENING_ANONYMOUS_ENDPOINT_SUFFIX = '/health-screening/anonymous/'

// Physician Endpoints
export const PHYSICIAN_ENDPOINT = `${API_BASE_URL}/api/physicians/`

// Attachment endpoints
export const ATTACHMENT_ENDPOINT_SUFFIX = '/attachment/'